"use strict";
/**
 * External Study Types
 *
 * Tracks studies sent to external labs (YiHealth, Annilab, Peninsular)
 * or imaging providers (USG/RX/ECO). Provides visibility on what's pending,
 * who requested it, and what post-result actions remain.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OVERDUE_THRESHOLD_DAYS = exports.ACTIVE_STUDY_STATUSES = exports.STUDY_STATUS_LABELS = exports.StudyStatus = void 0;
/**
 * Workflow state of an external study.
 *
 * Transitions:
 *   requested → sent → result_received → closed
 *                              ↓
 *                          cancelled (from any active state)
 *
 * Spanish UI labels are in `STUDY_STATUS_LABELS` — code/DB always uses English.
 *
 * Post-received actions (sentToInternalWhatsappAt, uploadedToQvetAt,
 * informedClientAt) are independent timestamps — not states.
 */
var StudyStatus;
(function (StudyStatus) {
    StudyStatus["requested"] = "requested";
    StudyStatus["sent"] = "sent";
    StudyStatus["result_received"] = "result_received";
    StudyStatus["closed"] = "closed";
    StudyStatus["cancelled"] = "cancelled";
})(StudyStatus || (exports.StudyStatus = StudyStatus = {}));
/** UI-only labels (Spanish). Code uses English enum values everywhere else. */
exports.STUDY_STATUS_LABELS = {
    [StudyStatus.requested]: 'Solicitado',
    [StudyStatus.sent]: 'Enviado',
    [StudyStatus.result_received]: 'Resultado recibido',
    [StudyStatus.closed]: 'Cerrado',
    [StudyStatus.cancelled]: 'Cancelado',
};
/**
 * Active states (not closed/cancelled). Used to filter pending dashboards.
 */
exports.ACTIVE_STUDY_STATUSES = [
    StudyStatus.requested,
    StudyStatus.sent,
    StudyStatus.result_received,
];
/**
 * Overdue thresholds in days (per category). Hardcoded for now; can move to
 * settings later. A study is "overdue" when (today - requestedAt) > threshold
 * AND status is in ACTIVE_STUDY_STATUSES.
 */
exports.OVERDUE_THRESHOLD_DAYS = {
    LAB: 5,
    IMAGING: 3,
};
